export const Divisor = () => (
  <div className="h-[2.438rem] w-px">
    <div className="bg-disabled h-[1.75rem] w-px" />
  </div>
);
